// @noflow
import { Border, Container, Label } from './style';

import PropTypes from 'prop-types';
import * as React from 'react';

Button.propTypes = {
    height: PropTypes.number.isRequired,
    isDisable: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    xPos: PropTypes.number.isRequired,
    yPos: PropTypes.number.isRequired
};

export default function Button({ height, isDisable, onClick, text, width, xPos, yPos, ...props }) {
    return (
        <Container
            data-qa={props['data-qa']}
            isDisable={isDisable}
            onClick={() => (isDisable ? null : onClick())}
            style={{ transform: `translate3d(${xPos}px, ${yPos}px, 0)` }}
            transform={`translate(${xPos} ${yPos})`}
        >
            <Border
                height={height}
                isDisable={isDisable}
                rx={height / 2}
                ry={height / 2}
                width={width}
                x={-width / 2}
                y={-height / 2}
            />
            <Label dy="5" isDisable={isDisable}>
                {text}
            </Label>
        </Container>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/control-panel/button/component.js